export const POSTING_DISCUSSION_START = 'posting_discussion_start';
export const POSTING_DISCUSSION_END = 'posting_discussion_end';
export const POSTING_DISCUSSION_SUCCESS = 'posting_discussion_success';
export const POSTING_DISCUSSION_FAILURE = 'posting_discussion_failure';

export const UPDATE_DISCUSSION_TITLE = 'update_discussion_title';
export const UPDATE_DISCUSSION_CONTENT = 'update_discussion_content';
export const UPDATE_DISCUSSION_PIN_STATUS = 'update_discussion_pin_status';
export const UPDATE_DISCUSSION_TAGS = 'update_discussion_tags';

export const CLEAR_SUCCESS_MESSAGE = 'clear_success_message';
